// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"style_pageContainer__3LWiA"};